import { z } from "zod";

import {
  processQueryResponse,
  processUserRequest,
} from "@/services/genAiService/types";
import http from "@/services/http";

export type ProcessQueryRequest = z.infer<typeof processUserRequest>;

export default async function processQuery(postRequest: ProcessQueryRequest) {
  processUserRequest.parse(postRequest);

  const { data } = await http().post(
    `${globalThis.env.API_GEN_AI}/process_query`,
    postRequest
  );

  return processQueryResponse.parse(data);
}
